import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from "rxjs/Observable";

@Injectable()
export class ServerProvider {

  headers;
  baseUrl = 'https://npsmd.supergenericwebsite.com';
  urls = {
    login: '/login',
    cases: '/server/cases/open',
    active: '/server/cases/open',
    options: '/options',
    notes: '/cases',
  };
  user;
  token = null;
  cases = [];
  loadingCases = true;

  constructor(public http: HttpClient) {
    this.setHeaders();
  }

  logout(){
    if( localStorage && localStorage.getItem('token') ){
      localStorage.clear();
      this.setHeaders();
    }
  }

  setHeaders(){
    if( localStorage && localStorage.getItem('token') ){
      this.token = localStorage.getItem('token');
      this.headers = { headers: new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', 'Bearer ' + this.token ) };
    } else {
      this.token = null;
      this.headers = {};
    }
  }

  getUrl( key ){
    if( this.urls[key] )
      return this.urls[key];
    else return null;
  }

  post( key, body, addition = null ){
    if( this.getUrl( key ) )
      return this.http.post( this.baseUrl+this.getUrl( key ) + ( addition ? '/'+addition : '' ), body, this.headers );
  }

  get( key, addition = null ){
    if( this.getUrl( key ) )
      return this.http.get( this.baseUrl+this.getUrl( key ) + ( addition ? '/'+addition : '' ), this.headers );
  }

  getCases(){
    this.loadingCases = true;
    console.log( 'Getting cases...' );
    this.get( 'cases' ).subscribe( (data:any)=>{
      this.loadingCases = false;
      console.log( data.data );
      this.cases = data.data;
    });
  }

  resizeImage( file, max_size, callback ){
    let reader = new FileReader();
    console.log("Loading reader...");
    reader.onload = (readerEvent:any)=>{
      console.log("reader loaded...");
      let image = new Image();
      image.onload = function(){
        let canvas = document.createElement('canvas');
        let width = image.width;
        let height = image.height;
        if (width > height) {
          if (width > max_size) {
            height *= max_size / width;
            width = max_size;
          }
        } else {
          if (height > max_size) {
            width *= max_size / height;
            height = max_size;
          }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        let dataUrl = canvas.toDataURL('image/jpeg', .7);
        callback( dataUrl );
      }
      image.src = readerEvent.target.result;
    }
    reader.readAsDataURL( file );
  }
}



// WEBPACK FOOTER //
// ./src/providers/server/server.ts